var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.75V6.25H3.75V3.75H16.25ZM16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V6.25C2.5 6.58152 2.6317 6.89946 2.86612 7.13388C3.10054 7.3683 3.41848 7.5 3.75 7.5H16.25C16.5815 7.5 16.8995 7.3683 17.1339 7.13388C17.3683 6.89946 17.5 6.58152 17.5 6.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM6.25 10V16.25H3.75V10H6.25ZM6.25 8.75H3.75C3.41848 8.75 3.10054 8.8817 2.86612 9.11612C2.6317 9.35054 2.5 9.66848 2.5 10V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H6.25C6.58152 17.5 6.89946 17.3683 7.13388 17.1339C7.3683 16.8995 7.5 16.5815 7.5 16.25V10C7.5 9.66848 7.3683 9.35054 7.13388 9.11612C6.89946 8.8817 6.58152 8.75 6.25 8.75ZM16.25 10V16.25H10V10H16.25ZM16.25 8.75H10C9.66848 8.75 9.35054 8.8817 9.11612 9.11612C8.8817 9.35054 8.75 9.66848 8.75 10V16.25C8.75 16.5815 8.8817 16.8995 9.11612 17.1339C9.35054 17.3683 9.66848 17.5 10 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V10C17.5 9.66848 17.3683 9.35054 17.1339 9.11612C16.8995 8.8817 16.5815 8.75 16.25 8.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.50e568461e8f825795329ee3f5927a5a.svg";
export { ForwardRef as ReactComponent };